module.exports = __webpack_public_path__ + "img/icon-s4.5a32305.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/signStatistics/icon-s4.png
// module id = vxea
// module chunks = 0 4 5 9